const selectText = { fontSize: '0.875rem', fontWeight: 500, color: '#222' };

export const customStyles = {
  control: (base: any, { selectProps }: any) => {
    const borderColor = String(selectProps?.className || '').includes('is-invalid') ? '#f93838' : '#d9d9d9';
    return {
      ...base,
      ...selectText,
      minHeight: selectProps.isMulti ? '2.375rem' : 'unset',
      border: `1px solid ${borderColor}`,
      borderRadius: '6px',
      backgroundColor: '#f8f8f8',
      boxShadow: 'none',
      outline: 'none',
      cursor: 'default',
      '&:hover': { borderColor }
    };
  },
  valueContainer: (base: any, { selectProps }: any) => ({
    ...base,
    flexWrap: 'wrap',
    gap: '0.25rem',
    padding: selectProps.isMulti ? '0.25rem 0.5rem' : '0.5rem',
    paddingRight: 0,
    alignItems: 'center'
  }),
  indicatorsContainer: (base: any) => ({
    ...base,
    alignSelf: 'center',
    padding: '0 0.25rem'
  }),
  indicatorSeparator: () => ({ display: 'none' }),
  dropdownIndicator: (base: any) => ({ ...base, padding: '0.5rem', color: '#222' }),
  clearIndicator: (base: any) => ({
    ...base,
    padding: '0.5rem',
    color: '#6c757d',
    ':hover': { color: '#222' }
  }),
  placeholder: (base: any) => ({ ...base, ...selectText, color: '#6c757d' }),
  singleValue: (base: any) => ({ ...base, ...selectText }),
  input: (base: any, { isHidden }: any) => ({
    ...base,
    margin: 0,
    padding: 0,
    ...selectText,
    ...(isHidden ? { width: 0, minWidth: 0 } : {})
  }),
  multiValue: (base: any) => ({
    ...base,
    margin: 0,
    backgroundColor: '#ebebeb',
    borderRadius: '4px',
    display: 'flex',
    alignItems: 'center',
    minHeight: '1.5rem'
  }),
  multiValueLabel: (base: any) => ({
    ...base,
    fontSize: '0.8125rem',
    fontWeight: 500,
    color: '#222',
    lineHeight: 1.25,
    padding: '0 0.375rem'
  }),
  multiValueRemove: (base: any) => ({
    ...base,
    display: 'flex',
    alignItems: 'center',
    alignSelf: 'stretch',
    color: '#6c757d',
    borderRadius: '0 4px 4px 0',
    padding: '0 0.375rem',
    ':hover': {
      backgroundColor: '#dde0e3',
      color: '#222'
    }
  }),
  menuPortal: (base: any) => ({ ...base, zIndex: 3 }),
  menu: (base: any) => ({ ...base, zIndex: 3 })
};

export const customStylesWithHighZIndex = {
  ...customStyles,
  menuPortal: (provided: any) => ({ ...provided, zIndex: 9999 })
};

export const physicianSelectOptions = [
  { value: 'None', label: 'None' },
  { value: 'Physician 1', label: 'Physician 1' }
];

export const PROGRAM_SELECT_OPTIONS = [
  { value: 'RPM', label: 'RPM' },
  { value: 'RTM', label: 'RTM' },
  { value: 'CCM', label: 'CCM' }
];

export const preventEnterSubmit = (keyEvent: any) => {
  if ((keyEvent.charCode || keyEvent.keyCode) === 13) {
    keyEvent.preventDefault();
  }
}

export const rawOptionsList = [
  { id: 1, name: 'Oxygen  + 33%', value: 'oxygen' },
  { id: 2, name: 'Diastolic  - 33%', value: 'diastolic' },
  { id: 3, name: 'Systolic  + 23%', value: 'systolic' },
  { id: 4, name: 'Pulse', value: 'pulse' },
  { id: 5, name: 'Temperature', value: 'temperature' },
  { id: 6, name: 'Weight', value: 'weight' },
  { id: 7, name: 'Fasting Blood Glucose', value: 'preprandial' },
  { id: 8, name: 'Non-Fasting Blood Glucose', value: 'postprandial' },
  { id: 9, name: 'INR', value: 'inr' }
];

export const TrimOptionsList = () => {
  const optionsArray = [];
  for (let i = 0; i <= 45; i++) {
    optionsArray.push(i);
    i = i + 4;
  }
  return optionsArray;
};
export const medicalTypesArray = ['None', 'MA', 'NP', 'PA', 'MD'];

export const PERMISSIONS = {
  TASKMODULE: 'taskmodule',
  TASKVIEW: 'taskview',
  TASKEDIT: 'taskedit',
  INVENTORYMODULE: 'inventorymodule',
  INVENTORYVIEW: 'inventoryview',
  INVENTORYEDIT: 'inventoryedit',
  DASHBOARDMODULE: 'dashboardmodule',
  SETTINGMODULE: 'settingmodule',
  USERVIEW: 'userview',
  USEREDIT: 'useredit',
  PROVIDERVIEW: 'providerview',
  PROVIDEREDIT: 'provideredit',
  ORGANIZATIONVIEW: 'organizationview',
  ORGANIZATIONEDIT: 'organizationedit',
  REPORTMODULE: 'reportmodule',
  CHATMODULE: 'chatmodule',
  PATIENTOPERATIONMODULE: 'patientoperationmodule',
  PATIENTHEALTHMODULE: 'patienthealthmodule',
  PATIENTINDIVIDUALMODULE: 'patientindividualmodule',
  PATIENTALLEDIT: 'patientalledit',
  PATIENTBASICVIEW: 'patientbasicview',
  PATIENTNOTEVIEW: 'patientnoteview',
  PATIENTREADINGVIEW: 'patientreadingview',
  PATIENTPERIODVIEW: 'patientperiodview',
  PATIENTEVENTVIEW: 'patienteventview',
  PATIENTMANUALVIEW: 'patientmanualview',
  PATIENTSCHEDULEVIEW: 'patientscheduleview',
  PATIENTFAXVIEW: 'patientfaxview',
  PATIENTSURVEYVIEW: 'patientsurveyview',
  PATIENTREFERRALVIEW: 'patientreferralview',
  PATIENTORGANIZATIONVIEW: 'patientorganizationview',
  LOCATIONMODULE: 'locationmodule',
  PATIENTGRIDDEFAULT: 'patientgriddefault',
  PATIENTGRIDPROVIDER: 'patientgridprovider',
  PATIENTUSERVIEW: 'patientuserview',
  PENDINGPATIENTMODULE: 'pendingpatientmodule',
  PENDINGPATIENTVIEW: 'pendingpatientview',
  PENDINGPATIENTALLEDIT: 'pendingpatientalledit',
  PENDINGPATIENTUPLOADVIEW: 'pendingpatientuploadview',
  CALENDARMODULE: 'calendarmodule',
  CALENDARVIEW: 'calendarview',
  CALENDAREDIT: 'calendaredit',
  RTMMODULE: 'rtmmodule',
  ENCOUNTERSIGNMODULE: 'encountersignmodule',
  DIGITALSIGNMODULE: 'digitalsignmodule',
  CUSTOMERPORTALMODULE: 'customerportalmodule',
  OPSDASHBOARDMODULE: 'opsdashboardmodule',
  OPSPMDASHBOARDMODULE: 'opspmdashboardmodule',
  TODAYSVISITMODULE: 'todaysvisitmodule'
}

export const ROLES = {
  ADMIN: 'admin',
  ATTENDANT: 'attendant',
  PROVIDER: 'provider',
  ORGANIZATION: 'organization',
  FAMILY: 'family',
  PATIENT: 'patient',
  REMOTE_ATTENDANT: 'remoteAttendant',
  SCHEDULER: 'scheduler',
  EDUCATOR: 'educator',
  VIRTUAL_NP: 'virtual NP',
  RTM_ADMIN: 'rtmAdmin'
} as const;

export const ROLE_LABELS: Record<string, string> = {
  [ROLES.ADMIN]: 'Admin',
  [ROLES.ATTENDANT]: 'Attendant',
  [ROLES.PROVIDER]: 'Provider',
  [ROLES.ORGANIZATION]: 'Organization',
  [ROLES.FAMILY]: 'Family',
  [ROLES.PATIENT]: 'Patient',
  [ROLES.REMOTE_ATTENDANT]: 'Remote Attendant',
  [ROLES.SCHEDULER]: 'Scheduler',
  [ROLES.EDUCATOR]: 'Educator',
  [ROLES.VIRTUAL_NP]: 'Virtual NP',
  [ROLES.RTM_ADMIN]: 'RTM Admin'
};

/** Human-readable labels for the user's roles (comma-separated when multiple). */
export const getRoleDisplayLabel = (roles: string[] | undefined): string => {
  if (!Array.isArray(roles) || roles.length === 0) {
    return '';
  }
  return roles
    .map((role) => ROLE_LABELS[role] ?? role)
    .join(', ');
};

export const USStates = [
  'AL', 'AK', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DE', 'FL', 'GA', 'HI', 'ID', 'IL', 'IN', 'IA', 'KS', 'KY', 'LA', 'ME', 'MD', 'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH', 'NJ', 'NM', 'NY', 'NC', 'ND', 'OH', 'OK', 'OR', 'PA', 'RI', 'SC', 'SD', 'TN', 'TX', 'UT', 'VT', 'VA', 'WA', 'WV', 'WI', 'WY', 'DC'
]

export const USStateWithFullName = [
  { value: 'AL', label: 'AL (Alabama)' },
  { value: 'AK', label: 'AK (Alaska)' },
  { value: 'AZ', label: 'AZ (Arizona)' },
  { value: 'AR', label: 'AR (Arkansas)' },
  { value: 'CA', label: 'CA (California)' },
  { value: 'CO', label: 'CO (Colorado)' },
  { value: 'CT', label: 'CT (Connecticut)' },
  { value: 'DE', label: 'DE (Delaware)' },
  { value: 'FL', label: 'FL (Florida)' },
  { value: 'GA', label: 'GA (Georgia)' },
  { value: 'HI', label: 'HI (Hawaii)' },
  { value: 'ID', label: 'ID (Idaho)' },
  { value: 'IL', label: 'IL (Illinois)' },
  { value: 'IN', label: 'IN (Indiana)' },
  { value: 'IA', label: 'IA (Iowa)' },
  { value: 'KS', label: 'KS (Kansas)' },
  { value: 'KY', label: 'KY (Kentucky)' },
  { value: 'LA', label: 'LA (Louisiana)' },
  { value: 'ME', label: 'ME (Maine)' },
  { value: 'MD', label: 'MD (Maryland)' },
  { value: 'MA', label: 'MA (Massachusetts)' },
  { value: 'MI', label: 'MI (Michigan)' },
  { value: 'MN', label: 'MN (Minnesota)' },
  { value: 'MS', label: 'MS (Mississippi)' },
  { value: 'MO', label: 'MO (Missouri)' },
  { value: 'MT', label: 'MT (Montana)' },
  { value: 'NE', label: 'NE (Nebraska)' },
  { value: 'NV', label: 'NV (Nevada)' },
  { value: 'NH', label: 'NH (New Hampshire)' },
  { value: 'NJ', label: 'NJ (New Jersey)' },
  { value: 'NM', label: 'NM (New Mexico)' },
  { value: 'NY', label: 'NY (New York)' },
  { value: 'NC', label: 'NC (North Carolina)' },
  { value: 'ND', label: 'ND (North Dakota)' },
  { value: 'OH', label: 'OH (Ohio)' },
  { value: 'OK', label: 'OK (Oklahoma)' },
  { value: 'OR', label: 'OR (Oregon)' },
  { value: 'PA', label: 'PA (Pennsylvania)' },
  { value: 'RI', label: 'RI (Rhode Island)' },
  { value: 'SC', label: 'SC (South Carolina)' },
  { value: 'SD', label: 'SD (South Dakota)' },
  { value: 'TN', label: 'TN (Tennessee)' },
  { value: 'TX', label: 'TX (Texas)' },
  { value: 'UT', label: 'UT (Utah)' },
  { value: 'VT', label: 'VT (Vermont)' },
  { value: 'VA', label: 'VA (Virginia)' },
  { value: 'WA', label: 'WA (Washington)' },
  { value: 'WV', label: 'WV (West Virginia)' },
  { value: 'WI', label: 'WI (Wisconsin)' },
  { value: 'WY', label: 'WY (Wyoming)' },
  { value: 'DC', label: 'DC (District of Columbia)' }
];

export const PHONE_TYPE_OPTIONS = [
  { value: 'Mobile', label: 'Mobile' },
  { value: 'Home', label: 'Home' },
  { value: 'Work', label: 'Work' }
];

export const LANGUAGE_OPTIONS = [
  { value: 'en', label: 'English' },
  { value: 'es', label: 'Spanish' },
  { value: 'vi', label: 'Vietnamese' },
  { value: 'zh', label: 'Mandarin' },
  { value: 'ar', label: 'Arabic' },
  { value: 'other', label: 'Other' }
];

export const CONTACT_METHOD_OPTIONS = [
  { value: 'Phone', label: 'Phone' },
  { value: 'SMS', label: 'SMS' },
  { value: 'Email', label: 'Email' }
];

export const DOCUMENT_CATEGORY_OPTIONS = [
  'Oasis',
  'CMS-485',
  'Medication List',
  'Patient Profile',
  'Photo ID',
  'Insurance Card',
  'Consent',
  'Clinical Record',
  'Device Documentation',
  'BP Device Serial Number',
  'Consent Form - Release of Information',
  'Consent Form - Consent for RPM & CCM',
  'Other'
];

export interface DeviceModelItem {
  deviceModel: string;
  deviceCompany: string;
  deviceType: string;
}

export const DEVICE_MODELS_LIST: DeviceModelItem[] = [
  { deviceModel: 'TMB-2092-Ga', deviceCompany: 'Transtek', deviceType: 'Blood Pressure and Pulse' },
  { deviceModel: 'BM1000', deviceCompany: 'Transtek', deviceType: 'Pulse Oximeter' },
  { deviceModel: 'TMB-2282-G', deviceCompany: 'Transtek', deviceType: 'Blood Glucose Meter' },
  { deviceModel: 'USM101', deviceCompany: 'Tellihealth', deviceType: 'Sleep Mate' },
  { deviceModel: 'GBS-2104-G', deviceCompany: 'Transtek', deviceType: 'Weight Scale' },
  { deviceModel: 'BPM Pro 2', deviceCompany: 'Withings', deviceType: 'Blood Pressure and Pulse' },
  { deviceModel: 'Sleep', deviceCompany: 'Withings', deviceType: 'Sleep' }
];

export const DEVICE_MODEL_OPTIONS = DEVICE_MODELS_LIST.map((item) => ({
  value: item.deviceModel,
  label: `${item.deviceModel} (${item.deviceCompany} - ${item.deviceType})`,
  company: item.deviceCompany,
  type: item.deviceType,
  model: item.deviceModel
}));


